<script>
import { AUTH_KEY } from "../utils/authToken.js";
import { useRuntimeConfig } from '#app'
import { getEnv, ENV } from "../utils";
import { iframeResize } from "iframe-resizer";

export default {
  props: {
    poster: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return localStorage.getItem(AUTH_KEY);
    },
    query() {
      return Object.keys(this.$route.params)
        .map((key) => key + "=" + this.$route.params[key])
        .join("&");
    },
    iframeUrl() {
      const config = useRuntimeConfig()
      return config.public.boughtService
    },
  },
  mounted() {
    iframeResize({ log: true }, "#buy_iframe");
    const buy_iframe = window.frames.buy_iframe;
    this.$refs.iframe.addEventListener("load", () => {
      try {
        // this.setIframeHeight('buy_iframe')
      } catch (e) {
        console.log(e);
      }
      buy_iframe.postMessage(
        JSON.stringify({
          type: "auth-key",
          message: localStorage.getItem(AUTH_KEY),
        }),
        "*"
      );
    });

    window.addEventListener("message", (event) => {
      try {
        const data = JSON.parse(event.data);
        switch (data?.type) {
          case "payment-created":
            this.$router.push({
              path: `/user/orders/${data.message}`,
            });
            break;
        }
      } catch (error) {
        console.log();
      }
    });
  },
};
</script>

<template>
  <iframe
    ref="iframe"
    class="w-full overflow-hidden"
    :class="[poster.kind === 'link' ? 'h-116 sm:h-200' : '']"
    :src="[
      poster.kind === 'link'
        ? `${poster.link}`
        : `${iframeUrl}/?${query}&token=${token}`,
    ]"
    name="buy_iframe"
    id="buy_iframe"
    scrolling="no"
    onload="iFrameResize()"
  />
</template>
